module.exports = "pegasus_template/assets/hexline-google.gif";